import { Questions, RubricBins, QuestionCategory } from '../models/questions';
import { ModelSettings } from '../models/modelsettings';
import {
  environment
} from '../../environments/environment';
import {
  Injectable
} from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';

import {
  retry,
  share
} from 'rxjs/operators';
import {
  Observable
} from 'rxjs';

@Injectable()
export class RunService {
  constructor(
    private http: HttpClient
  ) { }

  runTest(fileToUpload: File, model: ModelSettings): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.functionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('json', JSON.stringify(model));
    return this.http
      .post(`${environment.apiRoot}ML/Run`, formData, httpOptions)
      .pipe(share());
  }

  getQuestions(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.questionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };
    return this.http
      .get(`${environment.apiRoot}QuestionSetup/GetConfirmatoryQuestions`, httpOptions)
      .pipe(share());
  }

  getQuestionDataById(questionId: number, questionVersion = '0'): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.questionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };
  
    return this.http
      .get(`${environment.apiRoot}QuestionSetup/QuestionData/${questionId}/${questionVersion}`, httpOptions)
      .pipe(share());
  }

  getScoringModel(questionId: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.questionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };
    return this.http
      .get(`${environment.apiRoot}QuestionSetup/GetScoringModel/${questionId}`, httpOptions)
      .pipe(share());
  }

  getQuestionCats(questionId: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.questionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };
    return this.http
      .get(`${environment.apiRoot}QuestionSetup/GetQuestionCats/${questionId}`, httpOptions)
      .pipe(share());
  }

  getQuestionCatsByIdAndVersion(questionId: number, version: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.questionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };
    return this.http
      .get(`${environment.apiRoot}QuestionSetup/QuestionCats/${questionId}/${version}`, httpOptions)
      .pipe(share());
  }

  saveQuestion(question: Questions): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.questionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };
    const formData: FormData = new FormData();
    formData.append('json', JSON.stringify(question));
    return this.http
      .post(`${environment.apiRoot}QuestionSetup/Save`, formData, httpOptions)
      .pipe(share());
    // return this.http
    //   .post(`${environment.apiRoot}QuestionSetup/Save`, question, httpOptions)
    //   .pipe(share());
  }

  saveQuestionCategory(questionCat: QuestionCategory): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.questionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };
    const formData: FormData = new FormData();
    formData.append('json', JSON.stringify(questionCat));
    return this.http
      .post(`${environment.apiRoot}QuestionSetup/SaveQuestionCategory`, formData, httpOptions)
      .pipe(share());
  }

  // saveBins(rubric: RubricBins): Observable<any> {
  //   const httpOptions = {
  //     headers: new HttpHeaders()
  //       .set('Authorization', environment.questionsApiToken)
  //       .set('Accept', '*')
  //       .set('Access-Control-Allow-Origin', '*')
  //       .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
  //   };
  //   const formData: FormData = new FormData();
  //   formData.append('json', JSON.stringify(rubric));
  //   return this.http
  //     .post(`${environment.apiRoot}QuestionSetup/SaveBins`, formData, httpOptions)
  //     .pipe(share());
  // }
  saveBins(rubrics: RubricBins[]): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.questionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };

    return this.http
      .post(`${environment.apiRoot}QuestionSetup/SaveBins`, rubrics, httpOptions)
      .pipe(share());
  }

  deleteBin(binId: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', environment.questionsApiToken)
        .set('Accept', '*')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept')
    };

    return this.http
      .delete(`${environment.apiRoot}QuestionSetup/DeleteBin/${binId}`, httpOptions)
      .pipe(share());
  }
}
